import { GraphQLEnumType } from 'graphql';

module.exports = new GraphQLEnumType({
  name: 'QuestionOpinionEnum',
  values: {
    AGREEMENT: {
      value: 'AGREEMENT'
    },
    COMPARISON: {
      value: 'COMPARISON'
    },
    FREQUENCY: {
      value: 'FREQUENCY'
    },
    IMPORTANCE: {
      value: 'IMPORTANCE'
    },
    LIKELIHOOD: {
      value: 'LIKELIHOOD'
    },
    QUALITY: {
      value: 'QUALITY'
    }
  }
});
